export default "__VITE_ASSET__f9840484__"